var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"info-row__container"},[_c('p',{staticClass:"info-row__label"},[_vm._v(_vm._s(_vm.label))]),_c('p',{staticClass:"info-row__value"},[_vm._t("default",[_vm._v(_vm._s(_vm.value))])],2)])}
var staticRenderFns = []

export { render, staticRenderFns }